<template>
    <md-dialog class="add_dialog" :title="title" :closable="true" v-model="dialogopen" :btns="btns">
        <md-field title="Bonus ratio(%)">
            <div
                class="field-operator"
                slot="action"
                @click="bonusratio_onClick"
            >
                <md-icon name="info"></md-icon>
            </div>
            <md-input-item
                type="money"
                v-model="bonus_ratio"
                :brief="bonus_ratio_brief"
                :placeholder="'Max: ' + max_bonus_ratio + ' %'"
                :size="size"
                is-amount
                is-highlight
                :maxlength="4"
            >
                <div class="input-operator" slot="right" @click="set_max">Max</div>
            </md-input-item>
        </md-field>
    </md-dialog>
</template>
<script>
import { newreferral, editchilderbonusratio } from '@/request/api'
export default {
    name: 'bonusratiodialog',
    props: {
        title: {
            type: String,
            default: "Add Invite Link"
        },
        ch: {
            type: Object,
            default: null
        }
    },
    data(){
        return {
            dialogopen: false,
            btns: [
                {
                    text: 'Cancel',
                    handler: this.onDialogCancel,
                },
                {
                    text: 'Save',
                    handler: this.onDialogConfirm,
                },
            ],
            bonus_ratio: "",
            max_bonus_ratio: 0,
            bonus_ratio_brief: "You can get 0% Itoken",
            ch_id: "",
        }
    },
    watch: {
        bonus_ratio(newval) {
            if(Number(newval) > Number(this.max_bonus_ratio)) {
                this.bonus_ratio_brief = "You can get 0% Itoken"
            } else {
                this.bonus_ratio_brief = "You can get " + (Number(this.max_bonus_ratio) - Number(newval)).toFixed(2) + "% Itoken"
            }
        },
    },
    computed: {
        size() {
            return this.bonus_ratio.length > 10 ? 'small' : 'large'
        },
    },
    created() {
        this.$store.dispatch('asyncupdateuserinfo').then(res=>{
            this.max_bonus_ratio = res.bonus_ratio;
        });
    },
    methods: {
        onDialogCancel() {
			this.dialogopen = false;
		},
        showdialog() {
            if(this.ch) {
                this.bonus_ratio = this.ch.bonus_ratio;
                this.ch_id = this.ch.id;
            }
            this.dialogopen = true;
        },
        set_max() {
            this.bonus_ratio = this.$store.state.userinfo.bonus_ratio;
        },
        bonusratio_onClick() {
            Toast({
                content: 'Max ' + this.$store.state.userinfo.bonus_ratio + ' %',
                icon: 'warn',
            })
        },
        onDialogConfirm() {
            if(Number(this.bonus_ratio) > this.max_bonus_ratio) {
                this.$toast.failed('Max ' + this.max_bonus_ratio);
                return;
            }
            if(this.ch_id === "") {
                newreferral({bonus_ratio:this.bonus_ratio}).then(res=>{
                    if(res.code === 200) {
                        this.onDialogCancel();
                        this.$emit("on-createsuccess");
                    } else {
                        this.$toast.failed(res.errmsg);
                    }
                })
            } else {
                editchilderbonusratio({
                    id: this.ch_id,
                    bonus_ratio: this.bonus_ratio
                }).then(res=>{
                    if(res.code === 200) {
                        this.onDialogCancel();
                        this.$emit("on-createsuccess", this.bonus_ratio);
                    } else {
                        this.$toast.failed(res.errmsg);
                    }
                })
            }
		},
    }
}

</script>

<style scoped>
.add_dialog >>> .md-dialog-body {
    padding: 0.52rem 0 0 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/bonusratiodialog.vue